export const signupToggle = (data) => ({
  type: "SIGNUP_DATA",
  payload: data,
});

export const loginToggle = (data) => ({
  type: "LOGIN_DATA",
  payload: data,
});

export const createUserToggle = (data) => ({
  type: "CREATE_USER_DATA",
  payload: data,
});

export const setLogout = () => ({
  type: "LOGOUT_DATA",
});
